export interface SongEvent {
    id: string;
    title: string;
    start_at: string;
    end_at: string;
    songs: { id: string; start_at: string }[];
}

export interface EventCatalog { schema_version: 1; events: SongEvent[] }

export function parseEventCatalog(data: any): EventCatalog {
    const date = (value: unknown) => typeof value === 'string' && Number.isFinite(Date.parse(value));
    if (data?.schema_version !== 1 || !Array.isArray(data.events) || data.events.some((event: any) =>
        !event || typeof event.id !== 'string' || typeof event.title !== 'string'
        || !date(event.start_at) || !date(event.end_at) || Date.parse(event.start_at) > Date.parse(event.end_at)
        || !Array.isArray(event.songs) || event.songs.some((song: any) =>
            !song || typeof song.id !== 'string' || !date(song.start_at)))) {
        throw new Error('Invalid event schedule data');
    }
    return data;
}

export function currentSongEvents(catalog: EventCatalog | null, now: number) {
    const events = catalog?.events.filter(event => Date.parse(event.start_at) <= now && now <= Date.parse(event.end_at)) ?? [];
    const songIds = new Set(events.flatMap(event => event.songs
        .filter(song => Date.parse(song.start_at) <= now).map(song => song.id.toLowerCase())));
    return { events, songIds };
}
